import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColorSchemes } from 'src/styles/color-scheme.type';
import { DownloadFileCtx, FileLocation } from 'src/lib/fliko/models/http/downloadFile.data';
import { ImageViewerVM } from '../../interfaces/image-viewer.interface';
import { DialogService } from '../../services/dialog.service';
import { ImageViewerComponent } from '../image-viewer/image-viewer.component';

@Component({
  selector: 'app-image-preview-item',
  templateUrl: './image-preview-item.component.html',
  styleUrls: ['./image-preview-item.component.scss']
})
export class ImagePreviewItemComponent implements OnInit {
  /** storage path */
  @Input() photoPath: string = '';
  @Input() rawData?: string;
  @Input() size?: number | null;
  @Input() removeButton: boolean = false;
  @Input() fileLocation?: string;
  @Input() downloadContext?: Omit<DownloadFileCtx, 'storagePath' | 'fileUrl'>;
  @Input() viewerWidth = '90vw';
  @Input() viewerHeight = '90vh';
  @Input() viewerMaxWidth = '95vw';
  @Input() viewerMaxHeight = '90vh';
  @Input() viewerPanelClass?: string | string[];
  @Input() viewerLayout: ImageViewerVM['layout'] = 'default';
  @Input() viewerAuthorName?: string;
  @Input() viewerFileName?: string;
  @Input() viewerDownloadEstateId?: string;
  @Input() viewerDownloadLocation: FileLocation = FileLocation.DEFECTS;
  @Input() isCarousel?: boolean = false;
  @Input() colors: ColorSchemes = ColorSchemes.PRIMARY;

  @Output() onRemove = new EventEmitter<void>();

  public loaded: boolean = false;

  constructor(private dialogService: DialogService) {}

  ngOnInit() {}

  public showImage(path: string): void {
    this.dialogService.openSimpleDialog<ImageViewerComponent, ImageViewerVM>(
      ImageViewerComponent,
      {
        image: {
          path,
          rawData: this.rawData,
          fileName: this.viewerFileName,
          fileLocation: this.fileLocation ?? '',
          download: this.downloadContext
            ? { ...this.downloadContext, storagePath: path, fileUrl: null }
            : this.viewerDownloadEstateId && path
              ? { estateId: this.viewerDownloadEstateId, location: this.viewerDownloadLocation, storagePath: path, fileUrl: null }
              : undefined
        },
        layout: this.viewerLayout,
        authorName: this.viewerAuthorName
      },
      {
        width: this.viewerWidth,
        height: this.viewerHeight,
        maxWidth: this.viewerMaxWidth,
        maxHeight: this.viewerMaxHeight,
        panelClass: this.viewerPanelClass,
        autoFocus: false
      }
    );
  }
}
